<template>
  <div class="flex h-full">
    <NavSidebar />

    <div class="flex flex-col h-full w-full overflow-hidden">
      <Header />

      <div class="flex flex-col h-full overflow-hidden bg-info-400 p-24">
        <router-view #default="{ Component }">
          <transition name="fade" mode="out-in">
            <component :is="Component" />
          </transition>
        </router-view>
      </div>
    </div>
  </div>
</template>
